import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-200/70 border-t border-background-300/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading text-xl text-primary-500 mb-3">91美</h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {t('site.description')}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 whitespace-nowrap">
              {t('footer.services')}
            </h4>
            <ul className="space-y-2">
              <li><Link to="/categories" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">{t('categories.beauty')}</Link></li>
              <li><Link to="/categories" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">{t('categories.hair')}</Link></li>
              <li><Link to="/categories" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">{t('categories.nail')}</Link></li>
              <li><Link to="/categories" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">{t('categories.body')}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 whitespace-nowrap">
              {t('footer.about')}
            </h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">{t('about.brandStory')}</Link></li>
              <li><Link to="/articles" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">{t('nav.articles')}</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">{t('about.contact')}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 whitespace-nowrap">
              {t('about.contact')}
            </h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-phone-line text-primary-500"></i>
                <span className="whitespace-nowrap">{t('footer.phoneValue')}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-mail-line text-primary-500"></i>
                <span className="whitespace-nowrap">{t('footer.emailValue')}</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-600">
                <i className="ri-map-pin-line text-primary-500 mt-0.5"></i>
                <span>{t('footer.addressValue')}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500 whitespace-nowrap">
            {t('footer.copyright')}
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">{t('footer.privacy')}</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">{t('footer.terms')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}